import { useUser } from "src/hooks/useUser";

export const useEvaluator = () => {
    const { data: user, isLoading } = useUser();
    if (isLoading) {
        return undefined;
    }
    return user?.info.roles.includes("evaluator") ?? false;
};
